module.exports = __webpack_public_path__ + "img/img13.818188df.png";